if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

// window.onload = () => {
//     if(window.location.pathname === "/hideaways") {
//         setTimeout( () => {
//             const el = document.querySelector(`${window.location.hash}`);
//             el.scrollIntoView(false)
//             console.log(window.location.hash);
//         }, 2500);
//     }
// }

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    let url = document.URL;
    let form_id = "575"
    if( url.indexOf( "/contact" ) != "-1" ){
        let reason_for_inquiry = document.querySelector( `#form_id-${form_id} [name=reason_for_inquiry]` )
        if( reason_for_inquiry ){
            document.querySelector( `#form_id-${form_id}` ).innerHTML += '<input type="hidden" value="marketing@krcmaine.com" name="emailcc[]">'
           
            document.querySelector( `#form_id-${form_id} [name=reason_for_inquiry]` ).addEventListener( "change", (e) => {

                let hidden = document.createElement( "input" )
                hidden.type = "hidden"
                hidden.value = "dining@krcmaine.com"
                hidden.name = "emailcc[]"

                if( e.target.value == "restaurant" )
                    document.querySelector( `#form_id-${form_id}` ).appendChild( hidden )
                else
                    document.querySelector( `#form_id-${form_id} input[value="dining@krcmaine.com"]` ).remove()

            } )
                
        }
    }

    // Remove empty <p> tags created by tinymce


    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $('.sym-slides').slick({
        accessibility: false,
    }); 

    //slider with nav timer top content
    $('.slider-nav').not('.slick-initialized').slick({
        accessibility: false,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed:5000,
        focusOnSelect: false,
        dots: true,
        fade: true,
        appendDots: $('.slider-dots-box'),
        dotsClass: 'slider-dots',
        arrows: false,
     });
    // On before slide change
    $('.slider-nav').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.slider-dots-box button').html('');
    }).trigger('beforeChange');
    // On before slide change
    $('.slider-nav').on('afterChange', function(event, slick, currentSlide){
        $.each( $('.slider-dots-box button'), function(index, value){
            $( value ).html( "<p>0" + ( index + 1 ) + "</p>" );
        } )
        let current_index = $('.slider-dots-box .slick-active').index();
        
        $('.slider-dots-box .slick-active button')
        .html(`<svg class="progress-svg" width="40" height="40">
            <defs>
                <linearGradient id="gradient-1" x1="0%" y1="0%" x2="50%" y2="100%">
                <stop offset="0%" stop-color="#C7EFF5" />
                <stop offset="100%" stop-color="#38939b" />
                </linearGradient>
            </defs>
        <g transform="translate(19,19)">
            <circle class="circle-go" r="18" cx="0" cy="0" stroke="url(#gradient)" stroke-width="1" fill="none" ></circle>
        </g>
        </svg>
        ` + `<p>0` + ( current_index + 1 ) + `</p>`
        );
    }).trigger('afterChange');
    /*** end slick ***/

    //slider with nav timer used on slider quad
    $('.slider-block__nav').not('.slick-initialized').slick({
        accessibility: true,
        pauseOnHover: false,
        autoplay: true,
        autoplaySpeed: 30000,
        focusOnSelect: false,
        dots: true,
        arrows: false,
        appendDots: $('.slider-dots__box'),
        dotsClass: 'slider-dots',
    });
    // On before slide change
    $('.slider-block__nav').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.slider-dots__box button').html('');
    }).trigger('beforeChange');
    // On before slide change
    $('.slider-block__nav').on('afterChange', function(event, slick, currentSlide){
        
        $('.slider-dots__box .slick-active button')
        .html(`<svg class="progress-svg" width="40" height="40">
            <defs>
                <linearGradient id="gradient-2" x1="0%" y1="0%" x2="50%" y2="100%">
                <stop offset="0%" stop-color="#C7EFF5" />
                <stop offset="100%" stop-color="#38939b" />
                </linearGradient>
            </defs>
        <g transform="translate(19,19)">
            <circle class="circle-go" r="18" cx="0" cy="0" stroke="url(#gradient)" stroke-width="1" fill="none" ></circle>
        </g>
        </svg>
        ` 
        );
    }).trigger('afterChange');
    /*** end slick ***/

    //slider with nav timer used on slider quad
    $('.reviews-block__slider').not('.slick-initialized').slick({
        accessibility: false,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed:5000,
        focusOnSelect: false,
        dots: true,
        arrows: false,
        appendDots: $('.reviews-slider__nav'),
        dotsClass: 'slider-dots',
    });
    // On before slide change
    $('.reviews-block__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.reviews-slider__nav button').html(`<span class='hidden'>lorem text</span>`);
    }).trigger('beforeChange');
    // On before slide change
    $('.reviews-block__slider').on('afterChange', function(event, slick, currentSlide){
        
        $('.reviews-slider__nav .slick-active button')
        .html(`
        <span class='hidden'>lorem text</span>
        <svg class="progress-svg" width="40" height="40">
            <defs>
                <linearGradient id="gradient-3" x1="0%" y1="0%" x2="50%" y2="100%">
                <stop offset="0%" stop-color="#C7EFF5" />
                <stop offset="100%" stop-color="#38939b" />
                </linearGradient>
            </defs>
        <g transform="translate(19,19)">
            <circle class="circle-go" r="18" cx="0" cy="0" stroke="url(#gradient)" stroke-width="1" fill="none" ></circle>
        </g>
        </svg>
        ` 
        );
    }).trigger('afterChange');
    /*** end slick ***/

    $('.awards-block__slider').slick({
        arrows:true,
        autoplay: false,
		accessibility:false,
		slidesToShow :2,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow:1
				}
			}
		]
    });

    //vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}
			});
		}

		//outside click
		let alllightbox = document.getElementsByClassName('lightbox');
		let alllightLength = alllightbox.length;
		for(let j = 0; j < alllightLength; j++ ){
			alllightbox[j].addEventListener('click', function(){
				if(this.classList.contains('open')){
					this.classList.remove('open')
				}
			});
		}
    }
    


})();

/**setInterval( function(){

    $.each( $( "a" ), function( index, value ){
    var link = $( value ).attr( "href" ) ? $( value ).attr( "href" ) : "";
     if( (link.indexOf( "hiddenpondmaine.com" ) != "-1"
     || link.charAt(0) == "/" ) && !$( value ).attr( "_target" )
    ){
    $( value ).attr( "target", "_self" )
    }else{
    $( value ).attr( "target", "_blank" )
    }
    } )
    
}, 2000 ) */


